/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 */
import { orvalMutator } from "../config/orval/orvalMutator";

import type {
    GetApiInternalCampaignDraftId200,
    GetApiInternalCampaignV2Id200,
    ModelsCampaignV2Request2Body,
    ModelsCampaignV2RequestBody,
    ModelsGetCampaignV2ListRequest,
    PostApiInternalCampaignDraftId200,
    PostApiInternalCampaignV2200,
    PostApiInternalCampaignV2List200,
    PutApiInternalCampaignDraftId200,
    PutApiInternalCampaignV2Id200,
} from "../../schemas";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * GetCampaignDraft
 * @summary GetCampaignDraft
 */
export const getApiInternalCampaignDraftId = (
    id: string,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<GetApiInternalCampaignDraftId200>(
        { url: `/api/internal/campaign_draft/${id}`, method: "GET" },
        options,
    );
};
/**
 * UpdateCampaignDraft
 * @summary UpdateCampaignDraft
 */
export const putApiInternalCampaignDraftId = (
    id: string,
    modelsCampaignV2Request2Body: ModelsCampaignV2Request2Body,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PutApiInternalCampaignDraftId200>(
        {
            url: `/api/internal/campaign_draft/${id}`,
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            data: modelsCampaignV2Request2Body,
        },
        options,
    );
};
/**
 * CreateCampaignDraft
 * @summary CreateCampaignDraft
 */
export const postApiInternalCampaignDraftId = (
    id: string,
    modelsCampaignV2Request2Body: ModelsCampaignV2Request2Body,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalCampaignDraftId200>(
        {
            url: `/api/internal/campaign_draft/${id}`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsCampaignV2Request2Body,
        },
        options,
    );
};
/**
 * CreateCampaignV2
 * @summary CreateCampaignV2
 */
export const postApiInternalCampaignV2 = (
    modelsCampaignV2RequestBody: ModelsCampaignV2RequestBody,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalCampaignV2200>(
        {
            url: `/api/internal/campaign_v2`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsCampaignV2RequestBody,
        },
        options,
    );
};
/**
 * GetCampaignV2List
 * @summary GetCampaignV2List
 */
export const postApiInternalCampaignV2List = (
    modelsGetCampaignV2ListRequest: ModelsGetCampaignV2ListRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalCampaignV2List200>(
        {
            url: `/api/internal/campaign_v2/list`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsGetCampaignV2ListRequest,
        },
        options,
    );
};
/**
 * GetCampaignV2
 * @summary GetCampaignV2
 */
export const getApiInternalCampaignV2Id = (
    id: string,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<GetApiInternalCampaignV2Id200>(
        { url: `/api/internal/campaign_v2/${id}`, method: "GET" },
        options,
    );
};
/**
 * UpdateCampaignV2
 * @summary UpdateCampaignV2
 */
export const putApiInternalCampaignV2Id = (
    id: string,
    modelsCampaignV2RequestBody: ModelsCampaignV2RequestBody,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PutApiInternalCampaignV2Id200>(
        {
            url: `/api/internal/campaign_v2/${id}`,
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            data: modelsCampaignV2RequestBody,
        },
        options,
    );
};
export type GetApiInternalCampaignDraftIdResult = NonNullable<
    Awaited<ReturnType<typeof getApiInternalCampaignDraftId>>
>;
export type PutApiInternalCampaignDraftIdResult = NonNullable<
    Awaited<ReturnType<typeof putApiInternalCampaignDraftId>>
>;
export type PostApiInternalCampaignDraftIdResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalCampaignDraftId>>
>;
export type PostApiInternalCampaignV2Result = NonNullable<
    Awaited<ReturnType<typeof postApiInternalCampaignV2>>
>;
export type PostApiInternalCampaignV2ListResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalCampaignV2List>>
>;
export type GetApiInternalCampaignV2IdResult = NonNullable<
    Awaited<ReturnType<typeof getApiInternalCampaignV2Id>>
>;
export type PutApiInternalCampaignV2IdResult = NonNullable<
    Awaited<ReturnType<typeof putApiInternalCampaignV2Id>>
>;
